interface CriteriaCheckProps {
  met: boolean;
  label: string;
}

export function CriteriaCheck({ met, label }: CriteriaCheckProps) {
  return (
    <div className="flex items-center gap-2">
      {met ? (
        <span className="text-green-500 text-sm">✓</span>
      ) : (
        <span className="text-muted-foreground text-sm">○</span>
      )}
      <span className={met ? 'text-green-600 text-sm' : 'text-muted-foreground text-sm'}>
        {label}
      </span>
    </div>
  );
}
